<template>
  <div v-if="show" style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <!--кнопка закрытия модалки-->
      <button class="uk-close uk-close-large uk-modal-close-outside" type="button" data-uk-close @click="closeModal()"></button>
      <div class="uk-modal-body" style="padding-left: 70px; padding-right: 70px">
        <!--описание-->
        <div :data-uk-slider="'draggable: false;index:' + currentIndex +';'">
          <div class="uk-position-relative">
            <div class="uk-slider-container">
              <div class="uk-slider-items uk-child-width-1-1 tm-slider-example-items">
                <div
                    v-for="(item,i) in items"
                    :key="i"
                    :value="i">
                  <div class="tm-block-img uk-text-center tm-width-1-1 tm-slider-example-item" v-if="item.src_before && item.src_after">
                    <comparify :before="item.src_before" :after="item.src_after" :currentPageIsFunctionsDescription="currentPageIsFunctionsDescription">
                      <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
                      <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
                    </comparify>
                  </div>
                </div>
              </div>
              <a class="uk-position-center-left-out uk-position-medium" href data-uk-slidenav-previous data-uk-slider-item="previous"></a>
              <a class="uk-position-center-right-out uk-position-medium" href data-uk-slidenav-next data-uk-slider-item="next"></a>
              <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin-top"></ul>
            </div>
          </div>
        </div>
        <v-carousel v-model="currentIndex" v-if="false">
          <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :value="i"
              reverse-transition="fade-transition"
              transition="fade-transition">
            <div v-if="item.src_before && item.src_after" class="tm-block-img uk-text-center tm-width-1-1">
              <comparify :before="item.src_before" :after="item.src_after" :currentPageIsFunctionsDescription="currentPageIsFunctionsDescription">
                <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
                <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
              </comparify>
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import Comparify from "@/pages/Dashboard/Components/Comparify";

export default {
  props: {
    show: Boolean,
    prevOrderBlock: {type:Boolean, default: false},
    items: {type: [Array, Object]},
    showDialogFaceValue: {type: [Array, Object]},
  },
  // data: ()=> ({
  //   currentIndex: Number,
  // }),
  methods:{
    closeModal() {
      if(this.computedPrevOrderBlock){
        this.$emit('hide', {showDialog:true});
        this.$emit('catchOnHidePrev', {showDialog:true, parent_function_obj:this.computedShowDialogFaceValue});
      } else {
        this.$emit('hide', {showDialog:true});
        this.$emit('catchOnHide', {showDialog:true, parent_function_obj:this.computedShowDialogFaceValue});

      }

    },
  },
  computed: {
    currentIndex: {
      get: function () {
        return this.$parent.currentExampleCarouselIndex;
      },
      set: function (newValue) {
        this.$parent.currentExampleCarouselIndex = newValue;
      },
    },
    currentPageIsFunctionsDescription(){
      return document.location.pathname.indexOf('functions_description') !== -1;
    },
    computedPrevOrderBlock() {
      return this.prevOrderBlock;
    },
    computedShowDialogFaceValue(){
      return this.showDialogFaceValue;
    },
  },
  watch: {
    show: {
      handler(v) {
        if (v) {
          document.documentElement.classList.add('uk-modal-page');
        } else {
          document.documentElement.classList.remove('uk-modal-page');
        }
      }
    },
  },
  components: {
    Comparify,
  },

  async created() {
  },
}
</script>
<style>
  @import '../../../../assets/css/uikit/dotnav.css';
  @import '../../../../assets/css/uikit/slidenav.css';
  @import '../../../../assets/css/uikit/icon.css';

</style>